import { inject, Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import {
    selectCurrent,
    selectIsLoading,
    selectIsCreating,
    selectIsUpdating,
    selectAtLeastOneFolderExists,
    selectFolders,
    selectSelectedFolderForms,
    selectAtLeastOneFormExists,
    selectIsLoadingDetails,
} from "./selectors";
import { SmartFormFolder, SmartFormFoldersState } from "./model";
//import { SmartFormDefinition } from "@vhealth/engage";
import * as actions from "./actions";
import { assign } from "lodash";
import { SmartFormDefinition } from "../../model";

@Injectable({
    providedIn: "root",
})
export class SmartFormPoolFacade {
    private _store = inject(Store<SmartFormFoldersState>);

    _loading$: Observable<boolean> = this._store.select(selectIsLoading);

    _loadingDetails$: Observable<boolean> = this._store.select(selectIsLoadingDetails);

    _folders$: Observable<SmartFormFolder[]> = this._store.select(selectFolders);

    _selected$: Observable<SmartFormFolder> = this._store.select(selectCurrent);

    selectedFolderForms$: Observable<SmartFormDefinition[]> = this._store.select(selectSelectedFolderForms);

    isThereAnyForm$: Observable<boolean> = this._store.select(selectAtLeastOneFormExists);

    _isThereAnyData$: Observable<boolean> = this._store.select(selectAtLeastOneFolderExists);

    creating$: Observable<boolean> = this._store.select(selectIsCreating);

    updating$: Observable<boolean> = this._store.select(selectIsUpdating);

    constructor() {}

    get loading$() {
        return this._loading$;
    }

    get folders$() {
        return this._folders$;
    }

    get selected$() {
        return this._selected$;
    }

    root() {
        let folder = assign(new SmartFormFolder(), {
            id: 0,
            name: "Modelos",
            isPublic: true,
            folders: [],
            smartForms: [],
        });
        this.navigate(folder);
    }

    navigate(folder: SmartFormFolder, loadSmartForms: boolean = false) {
        this._store.dispatch(actions.loadSmartFormsAction.execute({ folder }));
    }

    select(folderId: number) {
        this._store.dispatch(actions.select({ folderId }));
    }

    goBack() {
        this._store.dispatch(actions.goBack());
    }

    createFolder(name: string, isPublic: boolean, parentFolderId: number = null) {
        this._store.dispatch(
            actions.createSmartFormFolderAction.execute({
                parentFolderId,
                name,
                isPublic,
            })
        );
    }

    updateFolder(id: number, name: string, isPublic: boolean) {
        this._store.dispatch(actions.updateSmartFormFolderAction.execute({ id, name, isPublic }));
    }

    deleteFolder(id: number) {
        this._store.dispatch(actions.deleteSmartFormFolderAction.execute({ id }));
    }

    createTemplate(smartFormDefinition: SmartFormDefinition) {
        this._store.dispatch(
            actions.createSmartFormDefinitionTemplateAction.execute({
                smartFormDefinition,
            })
        );
    }

    updateDefinitonTemplate(smartFormDefinition: SmartFormDefinition) {
        this._store.dispatch(actions.updateSmartFormAction.execute({ smartFormDefinition }));
    }

    moveFormDefinition(id: number, folderId: number) {
        this._store.dispatch(actions.moveFormDefinitionAction.execute({ id, folderId }));
    }

    deleteTemplate(id: number) {
        this._store.dispatch(actions.deleteSmartFormAction.execute({ id }));
    }

    loadSmartFormAction(folderId: number) {
        this._store.dispatch(actions.loadSmartFormDefinitionsAction.execute({ id: folderId }));
    }
}
